/**
 * @description
 * O default serve para colocar os valores que mais aparecem, para que só precise mudar nos diferentes e diminuir o trabalho braçal.
 * Tome cuidado pois elas serão setadas para todas as opções, você pode mudar manualmente em cada uma para setar diferentes.
 */
const ufsDefaultDefinitions = {
  na: true,
  uf: "RJ",
  logo: "logo_nacional.png",
  corPrimaria: "#5c8bb9",
  isIndicadores: false,
  isSala: false,
  isAT: false,
};

/**
 * @description
 * Valores referentes a cada tipo de municipio e suas respectivas definições, você deve colocar aqui somente nos caras que são
 * diferentes. Tente usar o ufsDefaultDefinitions para colocar as opções mais comuns entre eles.
 */
const ufsPorDefinitions = [
  //DEV
  {
    tag: "painel-inscricao-2024.selo",
    isSala: true,
    corPrimaria: "#2a4fd7",
    banco: "selo-inscricao-2025",
  },
  {
    tag: "painel-inscricao-2024.sistema",
    isSala: true,
    corPrimaria: "#2a4fd7",
    banco: "selo-inscricao-2025",
  },
  {
    tag: "painel-inscricao.sistema",
    isSala: true,
    corPrimaria: "#2a4fd7",
    banco: "selo-inscricao-2026",
  },
  {
    tag: "painel-inscricao-hlg.sistema",
    isSala: true,
    corPrimaria: "#2a4fd7",
    banco: "selo-inscricao-2026",
  },
  { tag: "localhost", uf: "SC", banco: "selo-inscricao-2026" },
];

const ufsDefinitions = ufsPorDefinitions.map((item) => {
  return { ...ufsDefaultDefinitions, ...item };
});

let atual;
let hrf = window.location.href;

ufsDefinitions.forEach((item) => {
  if (hrf.includes(item.tag)) {
    // urls com dev no nome
    if (item.tag.indexOf("dev") !== -1) {
      item.env = process.env.VUE_APP_BASE_API_DEV;
    }
    // urls com hlg no nome
    else if (item.tag.indexOf("hlg") !== -1) {
      item.env = process.env.VUE_APP_BASE_API_HLG;
      // urls com localhost no nome
    } else if (item.tag.indexOf("localhost") !== -1) {
      item.env = process.env.VUE_APP_BASE_API_LOCAL;
    }
    // produção
    else {
      if (!item.env) {
        item.env = process.env.VUE_APP_BASE_API_PROD;
      }
    }
    atual = { ...item, urlTag: item.tag };
  }
});

export const atualUfDefinition = atual;

/**
 *
 * @param {*} str - Essa string já vem automatica no filtro, não precisa passar
 * @param {*} tipo - cpf | telefone | email | nome
 * @returns
 */
export const esconderPalavras = (str, tipo) => {
  if (str) {
    if (tipo === "cpf") {
      return str.substring(0, 4) + "**" + str.substring(11, 14);
    } else if (tipo === "telefone") {
      return str.substring(0, 4) + "**" + str.substring(8, 11);
    } else if (tipo === "email") {
      let indexOfArroba = str.indexOf("@", 0);
      let indexOfArrobaDivided = parseInt(str.indexOf("@", 0) / 2);
      return (
        str.substring(0, indexOfArrobaDivided) +
        "**" +
        str.substring(indexOfArroba)
      );
    } else if (tipo === "nome") {
      let names = str.split(" ");
      if (names.length > 1) return names[0] + " " + names[names.length - 1];
      return names[0];
    }
  }
  return str;
};

export const sortArrayAsc = (a, b) => {
  if (a > b) return +1;
  if (a < b) return -1;
  return 0;
};
